module.exports = __webpack_public_path__ + "static/media/bingoBubble.d0b03b7b.png";